module.exports = __webpack_public_path__ + "static/img/11.4adcefc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/11.png
// module id = L1Qh
// module chunks = 0